// extracted by mini-css-extract-plugin
export default {"sort":"GR-z","sortSelect":"HR-z","disabled":"IR-z"};